var mapType = "topview";

$(function() {
	$('.form-group input').focusin(function() {
		$('.has-feedback').addClass("showClass");
		$(".form-control-feedback").addClass("search-icon-focus");
		$("#search-list").removeClass("hidden");
	});

	$('.form-group input').focusout(function() {
		$('.has-feedback').removeClass("showClass");
		$(".form-control-feedback").removeClass("search-icon-focus");
		setTimeout(function(){
			$('.form-group input').val("");
			cleanSearchList();
			filterSectionOnBlockmap([]);
			$("#search-list").addClass("hidden");
			if(!$('#search-list:hover')){
			}
		},150);
	});

	$(".search-form").mouseenter(function(){
		if(!$('.form-group input').is(":focus")){
			$(".form-control-feedback").addClass("search-icon-focus");
			if(!$('#search-list:hover')){
				$("#search-list").removeClass("hidden");
			}
		}
	}).mouseleave(function(){
		if(!$('.form-group input').is(":focus")){
			$(".form-control-feedback").removeClass("search-icon-focus");
			if(!$('#search-list:hover')){
				$("#search-list").addClass("hidden");
			}
		}
	});

	$('#search-list').mouseleave(function(){
		if(!$('.form-group input').is(":focus")){
			$('#search-list').addClass("hidden");
		}
	});
});

var currentFocus = 0;

function addActive(x) {
    /*a function to classify an item as "active":*/
    if (!x) return false;
    /*start by removing the "active" class on all items:*/
    removeActive(x);
    if (currentFocus >= x.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = (x.length - 1);
    /*add class "autocomplete-active":*/
	x[currentFocus].classList.add("active");

	let selected_sections = [];
	if(interf.current === mapType){
		var a = $(x[currentFocus]).attr("data-id");
		for(var i in interf.topview.hash){
			if (a.indexOf(i) !== -1){
				selected_sections.push(interf.topview.hash[i])
			}
		}

	}else{
		selected_sections.push($(".active").attr("data-id"));
	}
	filterSectionOnBlockmap(selected_sections);
    $(".active").get(0).scrollIntoView();
}

function afterListCreation(){
	$('.search-item').click(function(){
		if(interf.current === mapType){
			var a = $(this).attr("data-id");
			for(var i in interf.topview.hash){
				if (a.indexOf(i) !== -1){
					locateSeatmap(interf.topview.hash[i]);
				}
			}
		} else {
			locateSeatmap($(this).attr("data-id"));
		}
	});

	$('.search-item').mouseenter(function(){
		currentFocus = -1;
		$(".active").removeClass("active");
		$(this).addClass("active");
		let selected_sections = [];
		if(interf.current === mapType){
			var a = $(this).attr("data-id");
			for(var i in interf.topview.hash){
				if (a.indexOf(i) !== -1){
					selected_sections.push(interf.topview.hash[i]);
				}
			}
		} else {
			selected_sections.push($(".active").attr("data-id"));
		}
		filterSectionOnBlockmap(selected_sections);
	});

	var x = getSearchList();
	if(x.length > 0) x[currentFocus].classList.add("active");
}

function cleanSearchList(){
	$("#search-list").empty();
	currentFocus = 0;
}

function generateSearchList(id){
	var content = "<div class='search-item' data-id=''><span class='search-item-lab'>Section not found.</span></div>";
	if(typeof(id)!=="undefined"){
		content = "<div class='search-item' data-id=" + id +
		"><span class='search-item-lab'>Section </span><span class='search-item-val'>" +
		id.split("_")[1]+"</span></div>";
	}
	$("#search-list").append(content);
}

function getSearchList(){
	var x = document.getElementById("search-list");
    if(x) x = x.getElementsByTagName("div");
    return x;
}

function isKeyPressCharacter(evt) {
    if (typeof evt.which == "undefined") {
        // This is IE, which only fires keypress events for printable keys
        return true;
    } else if (typeof evt.which == "number" && evt.which > 0) {
        // In other browsers except old versions of WebKit, evt.which is
        // only greater than zero if the keypress is a printable key.
        // We need to filter out backspace and ctrl/alt/meta key combinations

		var x = getSearchList();
		
		if(evt.keyCode == 40 && $('input').val().length > 0){
        	// Arrow down
        	if(currentFocus <= x.length-1){
        		currentFocus++;
        	}
        	addActive(x);

        }else if(evt.keyCode == 38 && $('input').val().length > 0){
        	// Arrow up
        	if(currentFocus > -1){
        		currentFocus--;
        	}
        	addActive(x);
        }else if(evt.keyCode == 13 && $('input').val().length > 0){
        	// Enter
        	if (currentFocus > -1) {
	          /*and simulate a click on the "active" item:*/
	          if (x) x[currentFocus].click();
	        }
        }else{
        	return !evt.metaKey && !evt.altKey;
        }
    }
    return false;
}

function locateSeatmap(id){
	resetSearch();
	$(".contact-btn").addClass("hidden");
	$(".interior").addClass("hidden");
	$(".interior-mobile").addClass("hidden");
	var section = viewer.getNodeById(id);
	if(interf.current == "view3d"){
		setSeatmapDefaultDOM();
	}
	if(id != viewer.getMapId()){
		let obj = {
			nodes : [section]
		}
		onClickCB(obj);
    }
}

function onInputKeyPress(evt) {
	setTimeout(function(){
	    if (isKeyPressCharacter(evt)) {
			cleanSearchList();
			var selection = [];
			var searchVal = $('#search').val().toLowerCase();
			var sections = viewer.getNodesByType("section");
			if(interf.current === mapType ){
				console.log(searchVal);
				if (searchVal !== "") {
					var result = [];
					for (var blockID in interf.topview.hash) {
						if (blockID.toLowerCase().indexOf(searchVal) !== -1) {
							result.push(blockID);
						}
					}
					/*var result = sections.filter(function(blockID) {
						return blockID.toLowerCase().indexOf(searchVal) !== -1;
					});*/
	
					for (var i = 0; i < result.length; ++i) {
						var sectionID = result[i];
						generateSearchList(sectionID);
						var areaID = interf.topview.hash[sectionID];
						selection.push(areaID);
					}
				}
			} else {
				sections.forEach(function(sec){
					var searchVal = $('#search').val().toLowerCase();
					var sectionVal = sec.id.toLowerCase();
	
					if(searchVal !== "" && sectionVal.indexOf(searchVal) > -1){
						generateSearchList(sec.id);
						selection.push(sec.id);
					}
				});
			}
			
	    	if($('.form-group input').val().length > 0 && $('.form-group input').val()!=""){

		    	if(selection.length == 0){
					generateSearchList();
					filterSectionOnBlockmap([]);
		    	}else{
			    	filterSectionOnBlockmap(selection);
			    	afterListCreation();
		    	}
	    	}else{
				filterSectionOnBlockmap([]);
	    		cleanSearchList();
	    	}
		}
	},50);
}

function removeActive(x) {
    /*a function to remove the "active" class from all autocomplete items:*/
    for (var i = 0; i < x.length; i++) {
      x[i].classList.remove("active");
    }
}

function resetSearch(){
	currentFocus = 0;
	$('.form-group input').blur();
	$('#search-list').blur();
	$('.form-group input').val('');
	cleanSearchList();
	$("#search-list").addClass("hidden");
}

function filterSectionOnBlockmap(sections_oninput){
	console.log(sections_oninput);
	viewer.removeNodesFromGroup(viewer.getNodesByType("section"),"filtered");
	viewer.addNodesToGroup(sections_oninput,"filtered");
}


function searchHide(){
	$(".search-bar").addClass("hidden")
}
function searchShow(){
	$(".search-bar").removeClass("hidden")
}